import React from "react";
import "./loadAnimation.css";
import logo from "../../assets/images/logo.png";
import { OrbitProgress } from "react-loading-indicators";
const LoadAnimation = () => {
  return (
    <div className="load_container">
      <div className="grean_line"></div>
      <div className="red_line"></div>
      <div className="blue_line"></div>
      <div className="yellow_line"></div>
      <div className="logo_section">
        <img src={logo} />
      </div>
      <div className="loader">
        <OrbitProgress
          variant="dotted"
          color="black"
          size="small"
          text=""
          textColor=""
        />
      </div>
    </div>
  );
};

export default LoadAnimation;
